/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.DocumentKeywords";
        class DocumentKeywordsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("DocumentKeywordsWidgetTypeClass.createInstance()");
                    return new DocumentKeywordsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DocumentKeywordsWidgetTypeClass._storeHtml()");
                    DocumentKeywordsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentKeywordsWidgetTypeClass::constructor");
                if (DocumentKeywordsWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/DocumentKeywords/document-keywords.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.DocumentKeywordsWidgetTypeClass = DocumentKeywordsWidgetTypeClass;
        class DocumentKeywordsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._startEditButton = null;
                this._stealthHideButton = null;
                this._editContainer = null;
                this._cancelButton = null;
                this._revertButton = null;
                this._applyButton = null;
                this._directDocKeysEditEnabled = false;
                this._kwComponentContainer = null;
                this._kwComponent = null;
                // Management
                this._reactToSlots = [];
                this._lastReactedSlots = [];
                // State info
                this._collapseState = "Show";
                // Data
                this._currentDoc = null;
                this.presentInstance = () => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = DocumentKeywordsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._kwComponentContainer = this._container.querySelector('#docKeysKeywordsComponent');
                    this._startEditButton = this._container.querySelector('#docKeysEditButton');
                    this._startEditButton.addEventListener('click', this._startEdit);
                    this._core.Helper.setElementTranslationAttribute(this._startEditButton, 'title', 'STR_WPT_EDIT');
                    this._stealthHideButton = this._container.querySelector('#docKeysStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._core.Helper.setElementTranslationAttribute(this._stealthHideButton, 'title', 'STR_WPT_HIDE');
                    // Edit controls
                    this._editContainer = this._container.querySelector('#docKeysEditControls');
                    this._cancelButton = this._container.querySelector('#docKeysCancelBtn');
                    this._cancelButton.addEventListener('click', this.cancelEdits);
                    this._core.Helper.setElementTranslation(this._cancelButton.querySelector('#docKeysCancelBtnLabel'), 'STR_WPT_CANCEL');
                    this._revertButton = this._container.querySelector('#docKeysRevertBtn');
                    this._revertButton.addEventListener('click', this.revertEntries);
                    this._core.Helper.setElementTranslation(this._revertButton.querySelector('#docKeysRevertBtnLabel'), 'STR_WPT_REVERT');
                    this._applyButton = this._container.querySelector('#docKeysApplyBtn');
                    this._applyButton.addEventListener('click', this.applyEdits);
                    this._core.Helper.setElementTranslation(this._applyButton.querySelector('#docKeysApplyBtnLabel'), 'STR_WPT_APPLY');
                    this._widgets.setTitle(this._config, this._container.querySelector('#docKeysHeading'), 'STR_WPT_KEYWORDS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    // Set up component
                    let config = this._config;
                    if (config.hasOwnProperty("ReactToSlots") && (config.ReactToSlots != null))
                        this._reactToSlots = config.ReactToSlots;
                    else
                        this._reactToSlots = [];
                    if (config.hasOwnProperty("ReactToPrimary") && (config.ReactToPrimary) && (this._reactToSlots.indexOf(WPTNamespace.Utilities.PRIMARY_SLOT_KEY) == -1))
                        this._reactToSlots.push(WPTNamespace.Utilities.PRIMARY_SLOT_KEY);
                    if (config.hasOwnProperty("ReactToRelated") && (config.ReactToRelated) && (this._reactToSlots.indexOf(WPTNamespace.Utilities.RELATED_SLOT_KEY) == -1))
                        this._reactToSlots.push(WPTNamespace.Utilities.RELATED_SLOT_KEY);
                    if (config.hasOwnProperty('EnableDirectDocumentEdit') && (config.EnableDirectDocumentEdit != null)) {
                        this._directDocKeysEditEnabled = config.EnableDirectDocumentEdit;
                    }
                    if (config.hasOwnProperty('CollapseState') && (config.CollapseState != null)) {
                        this._collapseState = config.CollapseState;
                    }
                    if (this._collapseState == "Stealth")
                        this._core.Functions.showElement(this._stealthHideButton);
                    this._kwComponent = new Widgets.ComponentKeywordsViewEdit(this._core, this._kwComponentContainer, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.present();
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._callFailedHandler = (json) => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this.cancelEdits = () => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass.cancelEdits()");
                    this._core.Functions.hideElement(this._editContainer);
                    this._showKeysForDocument(this._currentDoc);
                    this._core.Functions.showElement(this._startEditButton);
                };
                this.revertEntries = () => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass.revertEntries()");
                    let request = {
                        Document: this._currentDoc,
                        Mode: WPTNamespace.MetadataEditors.KeywordEditMode.EDIT
                    };
                    this._kwComponent.makeRequest(request);
                };
                this.applyEdits = () => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass.applyEdits()");
                    if (!this._currentDoc)
                        return;
                    if (!this._kwComponent.Valid) {
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_ARCHIVE_KEYS_MISSING');
                        return;
                    }
                    let request = { KeywordRecords: this._kwComponent.KeywordRecords };
                    this._core.Loader.genericServiceCallWithData(`/Documents.svc/rest/UpdateKeywordRecords/${this._currentDoc.ItemNum}`, JSON.stringify(request), this._editApplied, {}, this._callErrorHandler, this._callFailedHandler);
                    this._core.Functions.showElement(this._startEditButton);
                    this._core.Functions.hideElement(this._editContainer);
                    this._kwComponent.Mode = WPTNamespace.MetadataEditors.KeywordEditMode.VIEW;
                };
                this._editApplied = (response) => {
                    
                    if (!response.hasOwnProperty('Documents') || (response.Documents == null) || (response.Documents.length == 0)) {
                        this.addError("Received no document records from keyword update request.");
                    }
                    else {
                        // Set local variable for brevity, and update current request
                        // We really shouldn't have more than one here, so ignore it if we somehow do
                        let doc = response.Documents[0];
                        this._showKeysForDocument(doc);
                        // Tell everyone what we've done
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._startEdit = (event) => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass._startEdit()");
                    this._core.Functions.hideElement(this._startEditButton);
                    this._kwComponent.Mode = WPTNamespace.MetadataEditors.KeywordEditMode.EDIT;
                    this._core.Functions.showElement(this._editContainer);
                };
                this._stealthHide = (event) => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this._showKeysForDocument = (doc) => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass._showKeysForDocument()");
                    this._clearErrors();
                    if (!doc) {
                        console.warn('DocumentKeywordsWidgetInstanceClass._showKeysForDocument() called with null document.');
                        return;
                    }
                    this._currentDoc = doc;
                    let request = {
                        Document: doc,
                        Mode: WPTNamespace.MetadataEditors.KeywordEditMode.VIEW
                    };
                    if (this._kwComponent.makeRequest(request)) {
                        if (this._directDocKeysEditEnabled)
                            this._core.Functions.showElement(this._startEditButton);
                        this._core.Functions.hideElement(this._editContainer);
                    }
                };
                this.clearDisplay = () => {
                    this._log.info("DocumentKeywordsWidgetInstanceClass.clearDisplay()");
                    this._kwComponent.clearDisplay();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentKeywordsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
            }
            activate(context) {
                this._log.info("DocumentKeywordsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // Don't respond to update events, we are directy working for another widget
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        this._lastReactedSlots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (this._lastReactedSlots.length > 0) {
                            if ((this._collapseState == "Stealth") && this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS) && context.Decloak)
                                this._core.Functions.showElement(this._outerDiv);
                            if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS))
                                this._showKeysForDocument(this._core.Context.PrimaryDocument);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED:
                        if (!this._outerDiv.classList.contains(WPTNamespace.HIDDEN_CLASS)) {
                            if (this._currentDoc.ItemNum == context.ActivationID)
                                this._showKeysForDocument(this._core.Context.PrimaryDocument);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this.clearDisplay();
                            if (this._collapseState == "Stealth")
                                this._core.Functions.hideElement(this._outerDiv);
                        }
                        break;
                }
            }
        }
        DocumentKeywordsWidgetInstanceClass.HtmlData = null;
        Widgets.DocumentKeywordsWidgetInstanceClass = DocumentKeywordsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
